"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueCustomAttributeMappingMigration = exports.IssueCustomAttributeBatchMigration = void 0;
var _IssueCustomAttributeMapping = require("../../types/IssueCustomAttributeMapping");
var _omit = _interopRequireDefault(require("lodash/omit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomAttributeMappingTypeMigration = {
  serialize(customAttributeMappingType) {
    switch (customAttributeMappingType) {
      case _IssueCustomAttributeMapping.IssueCustomAttributeMappingType.IssueType:
        return "issueSubtype";
      case _IssueCustomAttributeMapping.IssueCustomAttributeMappingType.IssueTypeCategory:
        return "issueType";
      case _IssueCustomAttributeMapping.IssueCustomAttributeMappingType.Project:
        return "container";
      default:
        return;
    }
  },
  deserialize(v2CustomAttributeMappingType) {
    switch (v2CustomAttributeMappingType) {
      case "issueType":
        return _IssueCustomAttributeMapping.IssueCustomAttributeMappingType.IssueTypeCategory;
      case "issueSubtype":
        return _IssueCustomAttributeMapping.IssueCustomAttributeMappingType.IssueType;
      default:
      case "container":
        return _IssueCustomAttributeMapping.IssueCustomAttributeMappingType.Project;
    }
  }
};
const IssueCustomAttributeMappingMigration = exports.IssueCustomAttributeMappingMigration = {
  serialize(issueCustomAttributeMapping) {
    return {
      ...(0, _omit.default)(issueCustomAttributeMapping, ["mappedItemType"]),
      mappedItemType: CustomAttributeMappingTypeMigration.serialize(issueCustomAttributeMapping.mappedItemType)
    };
  },
  deserialize(v2CustomAttributeMapping) {
    return {
      ...(0, _omit.default)(v2CustomAttributeMapping, ["mappedItemType"]),
      mappedItemType: CustomAttributeMappingTypeMigration.deserialize(v2CustomAttributeMapping.mappedItemType)
    };
  }
};
const IssueCustomAttributeBatchMigration = exports.IssueCustomAttributeBatchMigration = {
  serialize(batchPayload) {
    return {
      ...(0, _omit.default)(batchPayload, "mappedItemType"),
      mappedItemType: CustomAttributeMappingTypeMigration.serialize(batchPayload.mappedItemType)
    };
  },
  deserialize(batchResponse) {
    return batchResponse.map(IssueCustomAttributeMappingMigration.deserialize);
  }
};
//# sourceMappingURL=IssueCustomAttributeMappingMigration.js.map